import React from 'react';
import { FaArrowRight, FaGithub, FaLinkedin } from 'react-icons/fa';
import { SiFiverr } from 'react-icons/si';

const footerLinks = [
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Experience', href: '#experience' },
  { label: 'Education', href: '#education' },
  { label: 'Services', href: '#services' },
  { label: 'Certifications', href: '#certifications' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

const socialLinks = [
  { label: 'GitHub profile', href: 'https://www.github.com/hassan-yousuf', icon: FaGithub },
  { label: 'LinkedIn profile', href: 'https://www.linkedin.com/in/hassan-sakaria', icon: FaLinkedin },
  { label: 'Fiverr profile', href: 'https://www.fiverr.com/hassanyousuf786', icon: SiFiverr },
];

export default function Footer() {
  return (
    <>
      <section className="px-4 pb-20 pt-4 sm:px-6 lg:px-8" aria-labelledby="final-cta-title">
        <div className="site-container">
          <div className="relative overflow-hidden rounded-2xl border border-slate-700/70 bg-gradient-to-br from-indigo-500/15 via-slate-900/80 to-cyan-400/10 p-6 sm:p-10 lg:p-14">
            <div className="relative flex flex-col justify-between gap-8 sm:flex-row sm:items-end">
              <div>
                <p className="section-eyebrow">Ready to build?</p>
                <h2 id="final-cta-title" className="mt-5 max-w-xl text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Let&apos;s create something useful.</h2>
              </div>
              <a href="#projects" className="focus-ring inline-flex shrink-0 items-center justify-center rounded-full bg-white px-5 py-3.5 text-sm font-extrabold text-slate-950 transition hover:bg-cyan-200">View my work <FaArrowRight className="ml-2" aria-hidden="true" /></a>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-slate-800/70 px-4 py-10 sm:px-6 lg:px-8">
        <div className="site-container">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <div className="text-lg font-extrabold tracking-tight text-white">Hassan Yousuf</div>
              <p className="mt-2 text-sm text-slate-500">Flutter Developer · Mobile Application Development</p>
            </div>
            <nav aria-label="Footer navigation" className="flex max-w-2xl flex-wrap gap-x-5 gap-y-3">
              {footerLinks.map(({ label, href }) => <a key={href} href={href} className="focus-ring text-sm font-semibold text-slate-400 transition hover:text-white">{label}</a>)}
            </nav>
            <div className="flex items-center gap-3">
              {socialLinks.map(({ label, href, icon: Icon }) => (
                <a key={href} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="focus-ring flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 text-slate-400 transition hover:border-cyan-300/60 hover:text-cyan-200">
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
          <div className="mt-8 border-t border-slate-800/70 pt-6 text-xs text-slate-600">
            © {new Date().getFullYear()} Hassan Yousuf. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
}
